export const inthertedValue = (source, inherited, field) => {
  if ((source[field] === '' || source[field] === null) && inherited[field]) {
    return inherited[field]
  } else {
    return source[field]
  }
}

